import React from 'react';
import { Logo } from './Logo';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="w-full bg-gray-900 text-white py-12" data-id="element-122">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-124">
          <div data-id="element-125">
            <Logo className="text-white" data-id="element-126" />
            <p className="mt-4 text-gray-400" data-id="element-127">
              Transforming enterprises through comprehensive AI integration
              across all verticals.
            </p>
          </div>
          <div data-id="element-128">
            <h3 className="text-lg font-semibold mb-4" data-id="element-129">Solutions</h3>
            <ul className="space-y-2" data-id="element-130">
              <li data-id="element-131">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-132">
                  HR AI
                </a>
              </li>
              <li data-id="element-133">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-134">
                  Finance AI
                </a>
              </li>
              <li data-id="element-135">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-136">
                  Accounting AI
                </a>
              </li>
              <li data-id="element-137">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-138">
                  Operations AI
                </a>
              </li>
              <li data-id="element-139">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-140">
                  Vendor AI
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-141">
            <h3 className="text-lg font-semibold mb-4" data-id="element-142">Company</h3>
            <ul className="space-y-2" data-id="element-143">
              <li data-id="element-144">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors" data-id="element-145">
                  About Us
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-146">
            <h3 className="text-lg font-semibold mb-4" data-id="element-147">Contact</h3>
            <ul className="space-y-2" data-id="element-148">
              <li className="text-gray-400" data-id="element-149">info@nterpriseai.com</li>
              <li className="text-gray-400" data-id="element-150">
                Tudo Technologies Pvt Ltd,
                <br data-id="element-151" />
                43,
                <br data-id="element-152" />
                Residency Rd,
                <br data-id="element-153" />
                Shanthala Nagar,
                <br data-id="element-154" />
                Ashok Nagar,
                <br data-id="element-155" />
                Bengaluru,
                <br data-id="element-156" />
                Karnataka 560025
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-157">
          <p className="text-gray-400" data-id="element-158">
            © 2023 nterpriseAI. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 flex space-x-6" data-id="element-159">
            <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-160">
              Terms
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-161">
              Privacy
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-162">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>;
};